module.exports = __webpack_public_path__ + "img/14.e158f5f2.png";